<template>
  <el-dialog title="详情" :visible.sync="showModal" @close="handleCancel" width="40%">
    <el-col :span="24">
      <el-card shadow="none" class="bt-border4 mb-20">
        <div>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>编号：{{ actData.code }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>类型：{{ actData.type }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>网关：{{ actData.gateway }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>在线：{{ actData.status }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>电量：{{ actData.power }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>通道号：{{ actData.route }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>通道地址：{{ actData.address }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>频率：{{ actData.frequency }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>心跳：{{ actData.heartbeat }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>版本：{{ actData.version }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>上线时间：{{ actData.time }}</p>
        </div>
      </el-card>
    </el-col>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleCancel">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Number
    }
  },
  data() {
    return {
      showModal: this.isShow,
      actData: {
        code: '123',
        type: '123',
        gateway: 'asadasd',
        status: '在线',
        power: '80%',
        route: '1',
        address: '2',
        frequency: '2333',
        heartbeat: '12',
        version: 'V1.2',
        time: '2020-09-09 10:00:00'
      }
    }
  },
  watch: {
    isShow(val) {
      this.showModal = val
    }
  },
  methods: {
    handleCancel() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style></style>
